import { getAdvertiserExts, getProductDetails, getProducts, getTitleGroups, getUniLocalFenxiaoLinks, syncUniChangduLinks, getUniFenxiaoLinkInfo, getWorkers } from '@/api/open'
import { storeOrUpdateAdTask } from '@/api/ad-task'
import moment from 'moment'
import NoBSGS from './District'
import MaterialSelect from '@/components/material-select/MaterialSelect.vue'
import VideoSelect from '@/components/video-select/VideoSelect.vue'
import VideoRankSelect from '@/components/video-rank-select/VideoRankSelect.vue'
import OrgVideoSelect from '@/components/org-video-select/OrgVideoSelect.vue'
import CodeInput from '@/components/code-input/CodeInput.vue'
import AdvSelect from '@/components/adv-select/AdvSelect.vue'
import TitleGroup from '@/components/title-group/TitleGroup.vue'

export default {
    components: {
        MaterialSelect,
        VideoSelect,
        CodeInput,
        AdvSelect,
        TitleGroup,
        VideoRankSelect,
        OrgVideoSelect,
    },
    props: {
        params: {
            type: Object,
            required: true
        },
        media: {
            type: String,
            required: true
        },
        showCreateForm: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            advs: {},
            workers: [],
            showBindWorker: false,
            model: {
                task_type: 2,
                ids: [],
                name: '',
                worker_id: null,
                micro_promotion_type: 'AWEME',
                budget: 300,
                roi_goal: null,
                monetization_mode: 'IAP',
                audience_targeting: 'unlimited',
                audience: {
                    district: 'NONE',
                    gender: 'NONE',
                    age: ['BUDGET_MODE_INFINITE'],
                    platform: [''],
                },
                delivery_setting: {
                    schedule_type: 'SCHEDULE_FROM_NOW',
                    schedule_time_type: 1,
                    schedule_time: [],
                    schedule_date: [],
                },
                related_product: {
                    product_setting: 'SINGLE',
                    product_id: '',
                    playlet_id: '',
                },
                ad: {
                    num: 1,
                    title_num: 10,
                    name: '',
                    source: '',
                    native_setting: {
                        aweme_id: []
                    },
                    promotion_materials: {
                        call_to_action_buttons: [],
                        title_material_list: [],
                        product_info: {
                            titles: '',
                            image_ids: [],
                            selling_points: []
                        },
                    },
                    video_ids: [],
                    video_ids_local: [],
                    video_ids_rank: [],
                    video_ids_org: [],
                    video_hp_visibility: 'HIDE_VIDEO_ON_HP',
                    generate_mode: false,
                    source_model: 1,
                },
                product_model: 1,
                material_type: 1,
                need_product: 1,
                material_supplement: ['self'],
                aigc_dynamic_creative_switch: 'OFF',
                iaa_url_list: [],
                iap_url_list: [''],
                playlet_type: null,
            },
            ages: [
                { id: 'BUDGET_MODE_INFINITE', name: '不限' },
                { id: 'AGE_BETWEEN_18_23', name: '18-23' },
                { id: 'AGE_BETWEEN_24_30', name: '24-30' },
                { id: 'AGE_BETWEEN_31_40', name: '31-40' },
                { id: 'AGE_BETWEEN_41_49', name: '41-49' },
                { id: 'AGE_ABOVE_50', name: '50+' },
            ],
            platforms: [
                { id: '', name: '不限' },
                { id: 'ANDROID', name: 'Android' },
                { id: 'IOS', name: 'iOS' },
            ],
            buttons: [
                '点击观看',
                '继续观看',
                '看全集',
                '下一集',
                '精彩继续',
            ],
            sellingPoints: [
                '超热门火爆短剧',
                '必看热门短剧',
                '今天不看后悔一年',
            ],
            products: [],
            productDetails: {},
            loading: false,
            rules: {
                'ids': [{ required: true, message: '请选择广告主', trigger: 'change' }],
                'related_product.product_platform_id': [{ required: true, message: '请选择关联商品库', trigger: 'change' }],
                'related_product.product_id': [{ required: true, message: '请选择关联产品', trigger: 'change' }],
                'delivery_setting.schedule_date': [{ required: true, message: '请选择投放开始和结束时间', trigger: 'change' }],
                'delivery_setting.schedule_time_type': [{ required: true, message: '请选择投放时间段类型', trigger: 'change' }],
                'delivery_setting.schedule_time': [{ required: true, message: '请选择投放时间段', trigger: 'change' }],
                'budget': [{ required: true, message: '请输入日预算', trigger: 'change' }],
                'roi_goal': [{ required: true, message: '请输入全域ROI系数', trigger: 'change' }],
                'monetization_mode': [{ required: true, message: '请选择投放变现模式', trigger: 'change' }],
                'name': [{ required: true, message: '请输入项目名称', trigger: 'change' }],
                'ad.native_setting.aweme_id': [{ required: true, message: '请选择抖音号', trigger: 'change' }],
                'ad.video_ids': [{ required: true, message: '请选择账户视频素材', trigger: 'change' }],
                'ad.video_ids_local': [{ required: true, message: '请选择本地视频素材', trigger: 'change' }],
                'ad.video_ids_rank': [{ required: true, message: '请选择视频排行素材', trigger: 'change' }],
                'ad.video_ids_org': [{ required: true, message: '请选择组织素材', trigger: 'change' }],
                'ad.promotion_materials.title_material_list': [{ required: true, message: '请选择文案素材标题', trigger: 'change' }],
                'ad.promotion_materials.product_info.titles': [{ required: true, message: '请输入产品名称', trigger: 'change' }],
                'ad.promotion_materials.product_info.image': [{ required: true, message: '请选择产品主图', trigger: 'change' }],
                'ad.promotion_materials.product_info.selling_points': [{ required: true, message: '请输入产品卖点', trigger: 'change' }],
                'ad.promotion_materials.call_to_action_buttons': [{ required: true, message: '请输入行动号召', trigger: 'change' }],
            },
            currentAdvId: null,
            titleGroups: [],
            material_type: 1,
            visible: false,
            sources: [
                '晔彗网络科技',
                '点众快看',
                '七猫文化',
                '嘉兴飞杰',
                '大连剧鸣',
                '长沙烟若',
            ],
            product_titles: [
                '超热门火爆短剧',
                '热播短剧',
                '全程高能,处处精华',
                '必看热门短剧',
                '今天不看后悔一年',
            ],
            baseAdv: {},
            advertisers: [],
            activeTabKey: null,
            advertiserInfo: {},
            syncLocalLoading: false,
            syncChangduLoading: false,
            iaaLinkDescs: [],
            iapLinkDescs: [],
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '新建'
        },
    },
    watch: {
        'model.material_supplement'(val) {
            this.model.aigc_dynamic_creative_switch = val && val.includes('aigc') ? 'ON' : 'OFF'
        },
    },
    mounted() {
        if (this.params.params) {
            if (!this.params.params.delivery_setting) {
                this.params.params.delivery_setting = {}
            }
            if (!this.params.params.delivery_setting.schedule_date) {
                this.params.params.delivery_setting.schedule_date = []
            }
            if (!this.params.params.delivery_setting.schedule_time_type) {
                this.params.params.delivery_setting.schedule_time_type = 1
            }
            if (!this.params.params.delivery_setting.schedule_time) {
                this.params.params.delivery_setting.schedule_time = []
            } else {
                this.params.params.delivery_setting.schedule_time = this.params.params.delivery_setting.schedule_time.map(item => {
                    return !item ? [] : item
                })
            }
            this.params.params.product_model = this.params.params.product_model || 1
            this.params.params.ad = this.params.params.ad || {}
            if (!this.params.params.ad.video_ids_rank) {
                this.params.params.ad.video_ids_rank = []
            }
            if (!this.params.params.ad.video_ids_org) {
                this.params.params.ad.video_ids_org = []
            }
            if (!this.params.params.ad.native_setting) {
                this.params.params.ad.native_setting = { aweme_id: [] }
            }
            if (!this.params.params.ad.native_setting.aweme_id) {
                this.params.params.ad.native_setting.aweme_id = []
            }
            if (!this.params.params.budget) {
                this.params.params.budget = 300
            }
            if (!this.params.params.monetization_mode) {
                this.params.params.monetization_mode = 'IAP'
            }
            if (!this.params.params.audience_targeting) {
                this.params.params.audience_targeting = 'unlimited'
            }
            if (!this.params.params.material_supplement) {
                this.params.params.material_supplement = ['self']
            }
            if (!this.params.params.iap_url_list) {
                this.params.params.iap_url_list = ['']
            }
            if (!this.params.params.iaa_url_list) {
                this.params.params.iaa_url_list = []
            }
            if (!this.params.params.playlet_type) {
                this.params.params.playlet_type = null
            }
            this.params.params.task_type = 2
            this.model = Object.assign({}, this.$helper.deepClone(this.params.params))
            this.$set(this.model, 'ids', this.params.advertiser_ids)
            this.init()
            // 复制模式：自动加载关联产品详情，确保关联产品select有options显示
            if (this.model.related_product && this.model.related_product.product_platform_id && this.model.ids.length > 0) {
                this.getProductDetails(this.model.ids[0], this.model.related_product.product_platform_id, null, this.model.related_product.product_id).then(() => {
                    // 复制模式：根据关联产品自动拼接项目名称
                    this.autoBuildProjectNameFromProduct()
                })
            }
        } else if (this.params.ids) {
            this.$set(this.model, 'ids', this.params.ids)
            this.init()
        }

        if (this.model.ad.video_ids_local && this.model.ad.video_ids_local.length > 0) {
            this.material_type = 2
        } else if (this.model.ad.video_ids_rank && this.model.ad.video_ids_rank.length > 0) {
            this.material_type = 3
        } else if (this.model.ad.video_ids_org && this.model.ad.video_ids_org.length > 0) {
            this.material_type = 4
        } else {
            this.material_type = 1
        }

        getTitleGroups().then(res => { this.titleGroups = res.data.list || [] })
        // 仅新建模式（params 为空，无复制参数）：随机填充产品名称/卖点/行动号召 + 设置默认项目名称
        // 复制模式由 autoBuildProjectNameFromProduct 根据关联产品拼接，不随机
        if (!this.params.params) {
            this.randomInitCopywriting()
            this.model.name = '全域项目' + moment().format('_MM_DD_HH:mm:ss')
            this.model.ad.name = this.model.name.split('_')[0] + '_广告' + moment().format('_MM_DD_HH:mm:ss')
        }
    },
    methods: {
        // 新增模式一键随机：产品名称随机1个、产品卖点随机1个、行动号召随机2个
        randomInitCopywriting() {
            const title = this.product_titles[Math.floor(Math.random() * this.product_titles.length)]
            this.$set(this.model.ad.promotion_materials.product_info, 'titles', title)

            const sellingPoint = this.sellingPoints[Math.floor(Math.random() * this.sellingPoints.length)]
            this.$set(this.model.ad.promotion_materials.product_info, 'selling_points', [sellingPoint])

            const shuffled = [...this.buttons].sort(() => Math.random() - 0.5)
            this.$set(this.model.ad.promotion_materials, 'call_to_action_buttons', shuffled.slice(0, 2))
        },
        changeAdvs() {
            this.advertisers = []
            this.model.advertisers = []
            this.$nextTick(() => {
                if (this.currentAdvId !== this.model.ids[0]) {
                    this.$set(this.model, 'related_product', {
                        product_setting: 'SINGLE',
                        product_id: '',
                        playlet_id: '',
                    })
                    // 更换广告主后清空已选抖音号（需重新按商品专辑过滤）
                    this.$set(this.model.ad, 'native_setting', { aweme_id: [] })
                    this.model.ad.awemes = []
                    this.model.worker_id = null
                }
            })
            this.$nextTick(this.init)
        },
        init() {
            const refreshProduct = this.currentAdvId !== this.model.ids[0]
            const advertiserFilter = { advertiser_id: this.model.ids[0] }
            this.currentAdvId = this.model.ids[0]
            if (this.model.ids.length === 0) {
                return false
            }
            getAdvertiserExts({ ids: this.model.ids }).then(res => {
                this.advs = res.data.list || []
                // 任一广告主未绑定优化师则显示绑定选项，并拉取优化师列表
                this.showBindWorker = Object.values(this.advs).some(adv => !adv.worker_id)
                if (this.showBindWorker && this.workers.length === 0) {
                    getWorkers().then(r => { this.workers = r.data.list || [] })
                }
                let k = 0
                for (const key in this.advs) {
                    const adv = this.advs[key]
                    if (k === 0) {
                        this.baseAdv = adv
                    }
                    k++
                    const advertisers = this.model.advertisers || []
                    const existingAdvertiser = advertisers.find(item => item.id === adv.id)
                    const advertiserData = {
                        id: adv.id,
                        advertiser_id: adv.out_id,
                        name: adv.name,
                        product_platform_id: existingAdvertiser ? existingAdvertiser.product_platform_id : adv.product_platform_id,
                        product_id: adv.product_id,
                        playlet_id: existingAdvertiser ? existingAdvertiser.playlet_id : null,
                        product_setting: existingAdvertiser ? existingAdvertiser.product_setting : 'SINGLE',
                        project_name: existingAdvertiser ? existingAdvertiser.project_name : null,
                        ad: {
                            ad_name: existingAdvertiser ? existingAdvertiser.ad.ad_name : null,
                            source: existingAdvertiser ? existingAdvertiser.ad.source : adv.source,
                        }
                    }
                    this.addUniqueAdvertisers(advertiserData)
                }
                if (this.model.product_model == 2) {
                    for (const advertiser of this.advertisers) {
                        if (advertiser.product_platform_id && !advertiser.product_id) {
                            this.getProductDetails(advertiser.id, advertiser.product_platform_id)
                        }
                    }
                }
            })

            if (refreshProduct) {
                this.loading = true
                if (this.model.product_model == 2) {
                    let advertiserId = this.model.ids[0]
                    getProducts({ advertiser_id: advertiserId }).then(res => {
                        this.$set(this.products, advertiserId, res.data.list || [])
                    }).finally(() => {
                        this.loading = false
                    })
                    this.activeTabKey = advertiserId
                } else {
                    getProducts(advertiserFilter).then(res => {
                        this.$set(this.products, this.model.ids[0], res.data.list || [])
                    }).finally(() => {
                        this.loading = false
                    })
                }
            }
        },
        refreshProducts(adv_id = null, product_platform_id = null, product_id = null) {
            let advertiser_id = adv_id == null ? this.model.ids[0] : adv_id
            const advertiserFilter = { advertiser_id: advertiser_id }
            this.loading = true
            getProducts(advertiserFilter).then(res => {
                let this_adv_id = res.data.list || []
                this.products[advertiser_id] = this_adv_id
                this.$set(this.products, advertiser_id, this_adv_id)
            }).finally(() => {
                this.loading = false
            })
            if (product_platform_id > 0) {
                this.getProductDetails(adv_id, product_platform_id, null, product_id)
            }
        },
        refreshProductDetails(adv_id = null, product_platform_id = null) {
            if (product_platform_id > 0) {
                this.getProductDetails(adv_id, product_platform_id, 'refresh')
            }
        },
        handleUniAwemeChange(ids, items) {
            this.$set(this.model.ad, 'native_setting', { aweme_id: ids || [] })
            this.model.ad.awemes = items || []
        },
        materialTypeChange(key) {
            this.model.material_type = key
            this.material_type = key
        },
        changeVideo(item) {
            this.model.ad.video_ids_local = item
        },
        deleteImage() {
            this.$nextTick(() => {
                this.model.ad.promotion_materials.product_info.image = null
            })
        },
        showModal() {
            this.visible = true
        },
        handleOk() {
            this.visible = false
        },
        setTitleGroup(group) {
            this.$set(this.model.ad.promotion_materials, 'title_material_list', group.titles)
            this.$nextTick(() => {
                this.$refs.title_group.init()
            })
            this.visible = false
        },
        convertTimeSchedule(input) {
            const weekSchedule = Array(7).fill().map(() => Array(48).fill('0'))
            input.forEach((daySchedule, dayIndex) => {
                if (daySchedule && Array.isArray(daySchedule)) {
                    daySchedule.forEach(timeSlot => {
                        weekSchedule[dayIndex][timeSlot] = '1'
                    })
                }
            })
            return weekSchedule.map(day => day.join('')).join('')
        },
        getProductDetails(adv_id, product_platform_id, flag = null, product_id = '') {
            const json = {
                advertiser_id: adv_id,
                product_platform_id: product_platform_id,
                flag: flag
            }
            this.loading = true
            return getProductDetails(json).then(res => {
                let thisList = res.data.list || []
                const adv = this.advs[adv_id] || []
                if (this.model.product_model === 1) {
                    let videoName = null
                    if (adv.pt && adv.pt.video_name) {
                        videoName = adv.pt.video_name.split('-')[0].trim()
                    }
                    let matchedItem = null
                    if (videoName) {
                        matchedItem = thisList.find(item => item.name === videoName)
                    }
                    if (matchedItem) {
                        this.model.related_product.product_id = matchedItem.id
                        // 同步专辑ID，触发抖音号接口请求
                        this.$set(this.model.related_product, 'playlet_id', matchedItem.playlet_id || '')
                    } else {
                        this.model.related_product.product_id = product_id
                        // 无匹配时回填传入的 product_id，同步其 playlet_id（复制模式等）
                        const fallback = product_id ? thisList.find(item => String(item.id) === String(product_id)) : null
                        this.$set(this.model.related_product, 'playlet_id', fallback ? fallback.playlet_id : '')
                    }
                } else {
                    // 分别设置：按剧名(video_name)自动匹配产品，匹配失败则回填调用方显式传入的 product_id（复制模式等）
                    let targetAdvertiser = this.advertisers.find(ad => ad.advertiser_id === adv.out_id)
                    if (targetAdvertiser) {
                        let videoName = null
                        if (adv.pt && adv.pt.video_name) {
                            videoName = adv.pt.video_name.split('-')[0].trim()
                        }
                        let matchedItem = videoName ? thisList.find(item => item.name === videoName) : null
                        if (matchedItem) {
                            targetAdvertiser.product_id = matchedItem.id
                        } else if (product_id) {
                            // 匹配失败时回填传入的 product_id，并反查其 playlet_id
                            matchedItem = thisList.find(item => String(item.id) === String(product_id))
                            targetAdvertiser.product_id = product_id
                        }
                        // 同步专辑ID到广告主与顶层，触发抖音号接口请求
                        const playletId = matchedItem ? matchedItem.playlet_id : ''
                        targetAdvertiser.playlet_id = playletId || ''
                        this.$set(this.model.related_product, 'playlet_id', playletId || '')
                    }
                }
                this.$set(this.productDetails, product_platform_id, thisList)
            }).finally(() => {
                this.loading = false
            })
        },
        setBatchSource() {
            getAdvertiserExts({ ids: this.model.ids }).then(res => {
                this.advs = res.data.list || []
                let successCount = 0
                for (const key in this.advs) {
                    const adv = this.advs[key]
                    const existingAdvertiser = this.advertisers.find(item => item.id === adv.id)
                    if (existingAdvertiser) {
                        const existingAdvertiser2 = this.model.advertisers.find(item => item.id === adv.id)
                        const newSource = existingAdvertiser2 && existingAdvertiser2.ad && existingAdvertiser2.ad.source
                            ? existingAdvertiser2.ad.source
                            : adv.source || null
                        if (newSource !== null) {
                            existingAdvertiser.ad.source = newSource
                            successCount++
                        }
                    }
                }
                return this.$message.success('成功设置来源的广告主数量: ' + successCount)
            })
        },
        setBatchProduct() {
            getAdvertiserExts({ ids: this.model.ids }).then(res => {
                this.advs = res.data.list || []
                let successCount = 0
                for (const key in this.advs) {
                    const adv = this.advs[key]
                    const existingAdvertiser = this.advertisers.find(item => item.id === adv.id)
                    if (existingAdvertiser) {
                        const productPlatformId = adv.product_platform_id || null
                        if (productPlatformId !== null) {
                            existingAdvertiser.product_id = null
                            existingAdvertiser.playlet_id = null
                            existingAdvertiser.product_platform_id = productPlatformId
                            successCount++
                            // 加载该商品库的产品列表，并按剧名(video_name)自动匹配关联产品
                            this.getProductDetails(adv.id, productPlatformId)
                        }
                    }
                }
                return this.$message.success('成功设置商品库数量: ' + successCount)
            })
        },
        renderTab(advertiser, type = 'product') {
            let isGreen = false
            if (type === 'product') {
                isGreen = !!advertiser.product_platform_id && !!advertiser.product_id
            } else if (type === 'source') {
                isGreen = !!advertiser.ad.source
            }
            const isActive = advertiser.id === this.activeTabKey
            const color = isActive ? 'black' : isGreen ? 'green' : 'red'
            return (
                <span style={'color: ' + color}>
                    {advertiser.name}
                </span>
            )
        },
        changeAdvertiser(adv_id) {
            if (adv_id) {
                this.currentAdvId = adv_id
            } else {
                this.currentAdvId = this.model.ids[0]
            }
        },
        changeAge(v) {
            this.changeHandle(v, 'age', 'BUDGET_MODE_INFINITE')
        },
        changePlatform(v) {
            this.changeHandle(v, 'platform', '')
        },
        changeHandle(v, field, noneId) {
            if (v.length <= 1) {
                return true
            }
            if (v[v.length - 1] === noneId) {
                this.model.audience[field] = [noneId]
                return true
            }
            this.model.audience[field] = this.model.audience[field].filter(item => {
                return item !== noneId
            })
        },
        changeProductModel() {
            // 模式切换时清空对方模式已选的商品数据，避免脏数据影响抖音号过滤/提交回填
            if (this.model.product_model === 2) {
                // 切到分别设置：清空统一设置的商品数据与已选抖音号，保留各广告主商品数据
                this.$set(this.model, 'related_product', {
                    product_setting: 'SINGLE',
                    product_platform_id: '',
                    product_id: '',
                    playlet_id: '',
                })
                this.$set(this.model.ad, 'native_setting', { aweme_id: [] })
                this.model.ad.awemes = []
                if (this.advertisers.length > 0) {
                    let adv_id = this.advertisers[0].id
                    if (!this.products[adv_id]) {
                        this.refreshProducts(adv_id)
                    }
                    this.activeTabKey = adv_id
                }
            } else {
                // 切到统一设置：清空分别设置各广告主的商品数据、产品缓存与已选抖音号
                for (const advertiser of this.advertisers) {
                    advertiser.product_platform_id = null
                    advertiser.product_id = null
                    advertiser.playlet_id = null
                }
                this.productDetails = {}
                this.$set(this.model.ad, 'native_setting', { aweme_id: [] })
                this.model.ad.awemes = []
                this.activeTabKey = null
            }
        },
        clickPane(activeKey) {
            if (this.model.product_model === 2) {
                let adv_id = this.advertisers[activeKey].id
                let product_platform_id = this.advertisers[activeKey].product_platform_id
                let product_id = this.advertisers[activeKey].product_id
                if (!this.products[adv_id]) {
                    this.refreshProducts(adv_id, product_platform_id, product_id)
                }
                this.activeTabKey = adv_id
            }
        },
        changeLibrary(product_platform_id, option) {
            if (option === undefined || option === null) {
                return
            }
            let adv_id = option.data.attrs.adv_id ? option.data.attrs.adv_id : null
            if (!adv_id) {
                adv_id = this.model.ids[0]
                this.model.related_product.product_id = ''
            } else {
                if (this.model.product_model === 2) {
                    let advertiserObj = this.advertisers.find(ad => ad.id === adv_id)
                    advertiserObj.product_id = ''
                }
            }
            this.productDetails = {}
            this.getProductDetails(adv_id, product_platform_id)
        },
        changeProductDetail(productId, option) {
            // 统一设置：选择商品时记录专辑ID（playlet_id），用于抖音号过滤与占位锁定
            const playletId = option && option.data && option.data.attrs ? option.data.attrs.playlet_id : null
            this.$set(this.model.related_product, 'playlet_id', playletId || '')

            // 剧名 = 商品名称，选择商品后默认填充产品名称与项目名称
            const detail = option && option.data && option.data.attrs
                ? this.productDetails[this.model.related_product.product_platform_id]
                : null
            const selected = detail ? detail.find(item => String(item.id) === String(productId)) : null
            const dramaName = selected ? selected.name : ''
            if (dramaName) {
                this.$set(this.model, 'name', this.buildDefaultProjectName(dramaName))
            }
        },
        buildDefaultProjectName(dramaName) {
            // 项目名称默认：剧名_短剧全域投放项目_MM_DD_HH:mm:ss
            const time = moment().format('MM_DD_HH:mm:ss')
            return `${dramaName}_短剧全域投放项目_${time}`
        },
        // 复制模式：根据当前关联产品自动拼接项目名称（无需手动点击产品选择）
        autoBuildProjectNameFromProduct() {
            const productPlatformId = this.model.related_product && this.model.related_product.product_platform_id
            const productId = this.model.related_product && this.model.related_product.product_id
            if (!productPlatformId || !productId) {
                return
            }
            const list = this.productDetails[productPlatformId] || []
            const selected = list.find(item => String(item.id) === String(productId))
            const dramaName = selected ? selected.name : ''
            if (dramaName) {
                this.$set(this.model, 'name', this.buildDefaultProjectName(dramaName))
            }
        },
        changeAdvertiserProductDetail(productId, option) {
            // 分别设置：记录各广告主选择的商品专辑ID
            const playletId = option && option.data && option.data.attrs ? option.data.attrs.playlet_id : null
            const advId = option && option.data && option.data.attrs ? option.data.attrs.adv_id : null
            const advertiser = this.advertisers.find(ad => ad.id === advId)
            if (advertiser) {
                this.$set(advertiser, 'playlet_id', playletId || '')
                // 同步到统一字段，供抖音号过滤/短剧链接校验/提交使用（分别设置下各广告主专辑ID一致）
                this.$set(this.model.related_product, 'playlet_id', playletId || '')
            }
        },
        addUniqueAdvertisers(advertiser) {
            if (advertiser.id && !this.advertisers.some(item => item.id === advertiser.id)) {
                this.advertisers.push(advertiser)
            }
            this.advertisers.sort((a, b) => {
                const indexA = this.model.ids.indexOf(a.id)
                const indexB = this.model.ids.indexOf(b.id)
                return indexA - indexB
            })
        },
        disabledDate(current) {
            return current && moment(current).isBefore(moment().startOf('day'))
        },
        onMonetizationModeChange(e) {
            const mode = e.target.value
            if (mode === 'IAP') {
                this.model.iaa_url_list = []
                this.iaaLinkDescs = []
            } else if (mode === 'IAA_AND_IAP') {
                if (this.model.iaa_url_list.length === 0) {
                    this.model.iaa_url_list = ['']
                }
            }
        },
        addIapUrl() {
            if (this.model.iap_url_list.length < 10) {
                this.model.iap_url_list.push('')
                this.iapLinkDescs.push('')
            }
        },
        removeIapUrl(index) {
            this.model.iap_url_list.splice(index, 1)
            this.iapLinkDescs.splice(index, 1)
        },
        // 一键同步本地常读分销链接
        syncLocalLinks() {
            const playletId = this.model.related_product.playlet_id
            const playletType = this.model.playlet_type
            if (!playletId) {
                this.$message.error('请先选择关联产品')
                return
            }
            if (!playletType) {
                this.$message.error('请先选择短剧类型')
                return
            }
            this.syncLocalLoading = true
            getUniLocalFenxiaoLinks({ playlet_id: playletId, playlet_type: playletType }).then(res => {
                const data = res.data || {}
                const iaaLinks = data.iaa_links || []
                const iapLinks = data.iap_links || []
                this.fillLinks(iaaLinks, iapLinks)
                this.$message.success('同步成功')
            }).catch(() => {
                this.$message.error('同步失败')
            }).finally(() => {
                this.syncLocalLoading = false
            })
        },
        // 一键同步常读分销链接
        syncChangduLinks() {
            const playletId = this.model.related_product.playlet_id
            const playletType = this.model.playlet_type
            if (!playletId) {
                this.$message.error('请先选择关联产品')
                return
            }
            if (!playletType) {
                this.$message.error('请先选择短剧类型')
                return
            }
            this.syncChangduLoading = true
            syncUniChangduLinks({ playlet_id: playletId, playlet_type: playletType }).then(res => {
                const data = res.data || {}
                const iaaLinks = data.iaa_links || []
                const iapLinks = data.iap_links || []
                const errors = data.errors || []
                this.fillLinks(iaaLinks, iapLinks)
                if (errors.length > 0) {
                    this.$message.warning('同步完成，部分平台失败: ' + errors.join('; '))
                } else {
                    this.$message.success('同步成功')
                }
            }).catch(() => {
                this.$message.error('同步失败')
            }).finally(() => {
                this.syncChangduLoading = false
            })
        },
        // 单个链接blur时实时查询pt_fenxiaos显示描述
        onLinkBlur(type, index) {
            const link = type === 'iaa' ? this.model.iaa_url_list[index] : this.model.iap_url_list[index]
            if (!link || !link.trim()) {
                if (type === 'iaa') {
                    this.$set(this.iaaLinkDescs, index, '')
                } else {
                    this.$set(this.iapLinkDescs, index, '')
                }
                return
            }
            getUniFenxiaoLinkInfo({ link: link.trim() }).then(res => {
                const data = res.data || {}
                const desc = data.desc || ''
                if (type === 'iaa') {
                    this.$set(this.iaaLinkDescs, index, desc)
                } else {
                    this.$set(this.iapLinkDescs, index, desc)
                }
            }).catch(() => {
                // 查询失败不清空已有描述
            })
        },
        // 回填链接到表单
        fillLinks(iaaLinks, iapLinks) {
            // IAA链接（混合模式时填入，仅1条）
            if (this.model.monetization_mode === 'IAA_AND_IAP') {
                if (iaaLinks.length > 0) {
                    this.$set(this.model, 'iaa_url_list', [iaaLinks[0].link])
                    this.$set(this, 'iaaLinkDescs', [iaaLinks[0].desc || ''])
                }
            }
            // IAP链接（1-10条）
            if (iapLinks.length > 0) {
                this.$set(this.model, 'iap_url_list', iapLinks.map(item => item.link))
                this.$set(this, 'iapLinkDescs', iapLinks.map(item => item.desc || ''))
            }
        },
        // 从链接中解析 playlet_id
        parsePlayletIdFromLink(link) {
            if (!link) return null
            const match = String(link).match(/playlet_id=(\d+)/)
            return match ? match[1] : null
        },
        // 校验单条链接与商品专辑ID一致性
        getLinkValidationError(link) {
            if (!link) return null
            const expectedPlayletId = this.model.related_product.playlet_id
            if (!expectedPlayletId) return null
            const linkPlayletId = this.parsePlayletIdFromLink(link)
            if (linkPlayletId && linkPlayletId !== String(expectedPlayletId)) {
                return `短剧专辑链接和商品中的专辑id（${expectedPlayletId}）不一致`
            }
            return null
        },
        submit() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) {
                    this.$message.error('请完善所有必填表单项！')
                    return
                }

                // 视频素材校验（账户/本地/排行/组织四选一）
                let materialValid = true
                if (this.material_type === 1 && !this.model.ad.video_ids.length) {
                    this.$message.error('请选择账户视频素材')
                    materialValid = false
                } else if (this.material_type === 2 && !this.model.ad.video_ids_local.length) {
                    this.$message.error('请选择本地视频素材')
                    materialValid = false
                } else if (this.material_type === 3 && !this.model.ad.video_ids_rank.length) {
                    this.$message.error('请选择视频排行素材')
                    materialValid = false
                } else if (this.material_type === 4 && !this.model.ad.video_ids_org.length) {
                    this.$message.error('请选择组织素材')
                    materialValid = false
                }
                if (!materialValid) return

                // 素材数量校验（≤200）
                let videoCount = 0
                if (this.material_type === 1) videoCount = this.model.ad.video_ids.length
                else if (this.material_type === 2) videoCount = this.model.ad.video_ids_local.length
                else if (this.material_type === 3) videoCount = this.model.ad.video_ids_rank.length
                else if (this.material_type === 4) videoCount = this.model.ad.video_ids_org.length
                if (videoCount > 200) {
                    this.$message.error('视频素材不能超过200个')
                    return
                }

                // 短剧链接校验
                if (this.model.monetization_mode === 'IAP') {
                    const validIapUrls = this.model.iap_url_list.filter(u => u)
                    if (validIapUrls.length < 1) {
                        this.$message.error('IAP模式下至少需要1条IAP链接')
                        return
                    }
                    if (validIapUrls.length > 10) {
                        this.$message.error('IAP链接最多10条')
                        return
                    }
                } else if (this.model.monetization_mode === 'IAA_AND_IAP') {
                    const validIaaUrls = this.model.iaa_url_list.filter(u => u)
                    if (validIaaUrls.length !== 1) {
                        this.$message.error('混合模式下需要且仅需要1条IAA链接')
                        return
                    }
                    const validIapUrls = this.model.iap_url_list.filter(u => u)
                    if (validIapUrls.length < 1 || validIapUrls.length > 10) {
                        this.$message.error('混合模式下IAP链接需要1-10条')
                        return
                    }
                }

                // 短剧专辑链接与商品专辑ID一致性校验（不一致则阻断提交）
                const allLinks = [...this.model.iaa_url_list.filter(u => u), ...this.model.iap_url_list.filter(u => u)]
                for (const link of allLinks) {
                    const err = this.getLinkValidationError(link)
                    if (err) {
                        this.$message.error(err)
                        return
                    }
                }

                // 预算校验
                if (this.model.budget < 300) {
                    this.$message.error('日预算不能低于300元')
                    return
                }

                // ROI校验
                if (!this.model.roi_goal || this.model.roi_goal < 0.01 || this.model.roi_goal > 5) {
                    this.$message.error('全域ROI系数范围为0.01-5')
                    return
                }

                // 广告主数量不能大于抖音号数量（每个商品+抖音号只能投1个项目）
                const selectedAwemes = this.model.ad.native_setting.aweme_id || []
                const awemeCount = Array.isArray(selectedAwemes) ? selectedAwemes.length : (selectedAwemes ? 1 : 0)
                if (this.model.ids.length > awemeCount) {
                    this.$message.error('广告主数量不能大于抖音号数量！')
                    return
                }

                // 绑定优化师校验：存在未绑定优化师的广告主时必须选择优化师提交
                if (this.showBindWorker && !this.model.worker_id) {
                    this.$message.error('存在未绑定优化师的广告主，请选择优化师')
                    return
                }

                // 商品库校验
                let advertiserValid = true
                for (let advertiser of this.advertisers) {
                    if (this.model.need_product == 1 && this.model.product_model == 2) {
                        if (!advertiser.product_platform_id) {
                            this.$message.error('广告主【' + advertiser.name + '】的商品库不存在！')
                            advertiserValid = false
                            break
                        }
                        if (!advertiser.product_id) {
                            this.$message.error('广告主【' + advertiser.name + '】的商品不存在！')
                            advertiserValid = false
                            break
                        }
                    }
                }
                if (!advertiserValid) return

                // 分别设置下：所有广告主选择的关联商品专辑ID必须非空且一致，否则不能提交
                if (this.model.need_product == 1 && this.model.product_model == 2) {
                    const playletIds = this.advertisers.map(a => a.playlet_id).filter(Boolean)
                    if (playletIds.length !== this.advertisers.length) {
                        this.$message.error('所有广告主必须选择关联产品')
                        return
                    }
                    const uniquePlayletIds = [...new Set(playletIds.map(String))]
                    if (uniquePlayletIds.length > 1) {
                        this.$message.error('所有广告主选择的关联商品必须属于同一个专辑ID（当前：' + uniquePlayletIds.join(', ') + '）')
                        return
                    }
                }

                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            this.loading = true
            let json = Object.assign({}, this.model)
            json.advs = this.advs
            json.advertisers = this.advertisers

            // 提取 aweme_id 到顶层（后端需要）
            let awemeIds = this.model.ad.native_setting.aweme_id
            if (!Array.isArray(awemeIds)) {
                awemeIds = String(awemeIds).split(',').map(id => id.trim()).filter(Boolean)
            }
            json.aweme_id = awemeIds
            json.ad.awemes = this.model.ad.awemes || []

            // 商品专辑ID/商品库/商品：统一设置取顶层，分别设置取第一个广告主的（各广告主专辑ID已校验一致）
            if (this.model.product_model == 2 && this.advertisers.length > 0) {
                const first = this.advertisers[0]
                json.related_product.playlet_id = first.playlet_id || json.related_product.playlet_id || ''
                json.related_product.product_platform_id = first.product_platform_id || json.related_product.product_platform_id || null
                json.related_product.product_id = first.product_id || json.related_product.product_id || null
            } else if (!json.related_product.playlet_id && this.advertisers.length > 0) {
                json.related_product.playlet_id = this.advertisers[0].playlet_id || ''
            }

            // 处理地域定向
            if (this.model.audience_targeting === 'custom' && json.audience.district === 'REGION') {
                json.audience.city = NoBSGS
                json.audience.location_type = 'CURRENT'
                json.audience.region_version = '1.0.0'
            }
            // 定向调控为不限时清空定向数据
            if (this.model.audience_targeting === 'unlimited') {
                json.audience = {
                    district: 'NONE',
                    gender: 'NONE',
                    age: ['BUDGET_MODE_INFINITE'],
                    platform: [''],
                }
            }

            json.material_type = this.material_type

            // 提取投放设置到顶层（后端从顶层取值）
            json.schedule_type = json.delivery_setting.schedule_type || 'SCHEDULE_FROM_NOW'
            json.schedule_time_type = json.delivery_setting.schedule_time_type || 1
            // 处理投放时段
            if (this.model.delivery_setting.schedule_time_type == 2) {
                json.delivery_setting.final_schedule_time = this.convertTimeSchedule(json.delivery_setting.schedule_time)
                json.week_schedule = json.delivery_setting.final_schedule_time
            }
            // 处理投放时间
            if (this.model.delivery_setting.schedule_type == 'SCHEDULE_START_END') {
                json.delivery_setting.start_time = json.delivery_setting.schedule_date[0]
                json.delivery_setting.end_time = json.delivery_setting.schedule_date[1]
                json.start_time = json.delivery_setting.start_time
                json.end_time = json.delivery_setting.end_time
            }

            // 处理短剧链接
            json.iaa_url_list = this.model.iaa_url_list.filter(u => u)
            json.iap_url_list = this.model.iap_url_list.filter(u => u)

            // 处理AIGC开关
            json.aigc_dynamic_creative_switch = this.model.aigc_dynamic_creative_switch

            storeOrUpdateAdTask(this.media, json).then(() => {
                this.$message.success('提交成功')
                this.loading = false
                this.close()
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$emit('success')
            this.$emit('update:showCreateForm', false)
        },
    }
}
